import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../auth/useAuth";
import { odataFetch } from "../../lib/odata-fetch";
import {
  RemoveEquipmentPreferencesForUser2Params,
  RemoveEquipmentPreferencesForUserResponse,
} from "../../odata/appu4dm/AppU4DMModel";
import { QRemoveEquipmentPreferencesForUser } from "../../odata/appu4dm/QAppU4DM";
import { machineKeys } from "./machine-keys";

export function useResetMachine(onSuccess?: VoidFunction) {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const { token } = queryClient.getDefaultOptions().queries?.meta ?? {};

  const { mutate, ...mutation } = useMutation({
    mutationFn: () => resetMachine(token!),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: machineKeys.get(user?.unique_name),
      });

      onSuccess?.();
    },
  });

  return {
    resetMachine: mutate,
    ...mutation,
  };
}

export async function resetMachine(token: string) {
  const builder = createQueryBuilderV4(
    "RemoveEquipmentPreferencesForUser",
    new QRemoveEquipmentPreferencesForUser()
  );

  return odataFetch<
    RemoveEquipmentPreferencesForUserResponse,
    RemoveEquipmentPreferencesForUser2Params
  >({
    builder,
    token,
    method: "POST",
    body: { command: {} },
  });
}
